/**
 * Tags the currently rendered vng-tour prev/next/end buttons with
 * `data-fms-heap` attributes for Heap analytics tracking. The prev button
 * receives `${heapPrefix}-prev`, the next button `${heapPrefix}-next`, and
 * the end ("Got it!"/single-step-dismiss) button `${heapPrefix}-end`; buttons
 * that are not present in the DOM (e.g. `--end` only renders on a tour's last
 * step, `--prev`/`--next` never render on a single-step tour) are silently
 * skipped.
 */
export function tagTourStepButtons(heapPrefix: string): void {
  const prevButton = document.querySelector(".vng-tour-step__btn--prev");
  const nextButton = document.querySelector(".vng-tour-step__btn--next");
  const endButton = document.querySelector(".vng-tour-step__btn--end");

  if (prevButton) {
    prevButton.setAttribute("data-fms-heap", `${heapPrefix}-prev`);
  }

  if (nextButton) {
    nextButton.setAttribute("data-fms-heap", `${heapPrefix}-next`);
  }

  if (endButton) {
    endButton.setAttribute("data-fms-heap", `${heapPrefix}-end`);
  }
}
